import { SVGIconProps } from './types'

export const RestoreToHeadCommitIcon = ({
  width = 12,
  height = 14,
  ...props
}: SVGIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.65628 10.7504C5.7806 10.7504 5.89983 10.701 5.98774 10.6131C6.07565 10.5252 6.12503 10.4059 6.12503 10.2816L6.12503 2.50681L9.54339 5.92576C9.58694 5.96931 9.63865 6.00386 9.69555 6.02743C9.75245 6.051 9.81344 6.06313 9.87503 6.06313C9.93662 6.06313 9.99761 6.051 10.0545 6.02743C10.1114 6.00386 10.1631 5.96931 10.2067 5.92576C10.2502 5.88221 10.2848 5.8305 10.3083 5.7736C10.3319 5.7167 10.344 5.65571 10.344 5.59412C10.344 5.53253 10.3319 5.47154 10.3083 5.41464C10.2848 5.35773 10.2502 5.30603 10.2067 5.26248L5.98792 1.04373C5.94439 1.00015 5.89269 0.965571 5.83578 0.941982C5.77888 0.918392 5.71788 0.90625 5.65628 0.90625C5.59468 0.90625 5.53368 0.918392 5.47678 0.941982C5.41987 0.965571 5.36817 1.00015 5.32464 1.04373L1.10589 5.26248C1.06234 5.30603 1.02779 5.35773 1.00422 5.41464C0.980652 5.47154 0.968521 5.53253 0.968521 5.59412C0.968521 5.65571 0.980652 5.7167 1.00422 5.7736C1.02779 5.8305 1.06234 5.88221 1.10589 5.92576C1.14944 5.96931 1.20115 6.00386 1.25805 6.02743C1.31495 6.051 1.37594 6.06313 1.43753 6.06313C1.49912 6.06313 1.56011 6.051 1.61701 6.02743C1.67392 6.00386 1.72562 5.96931 1.76917 5.92576L5.18753 2.50681L5.18753 10.2816C5.18753 10.4059 5.23692 10.5252 5.32483 10.6131C5.41273 10.701 5.53196 10.7504 5.65628 10.7504Z"
        fill="currentColor"
      />
      <path
        d="M0.168544 12.2935C0.0806361 12.3815 0.03125 12.5007 0.03125 12.625C0.03125 12.7493 0.0806361 12.8685 0.168544 12.9565C0.256451 13.0444 0.37568 13.0937 0.5 13.0937L10.8125 13.0937C10.9368 13.0937 11.056 13.0444 11.144 12.9565C11.2319 12.8685 11.2812 12.7493 11.2812 12.625C11.2812 12.5007 11.2319 12.3815 11.144 12.2935C11.056 12.2056 10.9368 12.1562 10.8125 12.1562L0.5 12.1562C0.37568 12.1562 0.256451 12.2056 0.168544 12.2935Z"
        fill="currentColor"
      />
    </svg>
  )
}
